import { render, staticRenderFns } from "./ListTransition.vue?vue&type=template&id=38f1c6bb"
import script from "./ListTransition.vue?vue&type=script&lang=js"
export * from "./ListTransition.vue?vue&type=script&lang=js"
import style0 from "./ListTransition.vue?vue&type=style&index=0&id=38f1c6bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports